import { PromptCategory } from './types';

export const PROMPT_CATEGORIES: PromptCategory[] = [
  {
    label: 'Transport & Mobility',
    prompts: [
      'Do you have datasets on low emission zones in Asia?',
      'I am about to embark on a transport sector project and would like to learn from similar projects previously done in ADB.',
      'I would like to identify hotspots in maritime activity due to cyclone events.',
    ],
  },
  {
    label: 'Social Impact',
    prompts: [
      'Do you have datasets on social protection indicators?',
      'Is there an AI product that can help me find insights from ADB documents on the social impacts of past projects and how ADB managed them?',
      'I would like to understand the social impact that disaster events can have on a country. Show me relevant assets and explain how each could support the assessment.',
    ],
  },
  {
    label: 'Climate & Disaster Risk',
    prompts: [
      'Do you have datasets on flood risks in Asia and the Pacific region?',
      'I would like to conduct a climate and disaster risk analysis for a potential project in The Pacific. Are there any existing solutions I can use?',
      'I would like to understand the relationship between disaster events and population movement. Show me relevant assets and explain how each could support the assessment.',
    ],
  },
  {
    label: 'Credit Risk',
    prompts: [
      'Do you have the standard industry economic activity classification codes?',
      'I would like to conduct a credit risk assessment for ADB’s NonSovereign Operations. Are there any existing solutions I can use?',
      "I would like to understand the historic global economic conditions of ADB's member countries to evaluate loan risks. Show me relevant assets and explain how each could support the assessment.",
    ],
  },
];
